export default __webpack_public_path__ + "static/media/embed.78c81ce3.svg";